var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.set)?_c('div',{staticClass:"container"},_vm._l((_vm.sortedParts),function(part){return _c('part-box',{key:part.id + '-' + part.color.id,attrs:{"part":part},nativeOn:{"click":function($event){_vm.clickPart(part.id + '-' + part.color.id)}}})})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eac7df8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts.vue
// module id = null
// module chunks = 